const initialState = {
    elements: {}
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case 'SET_ELEMENT_CANONICAL':
            return {
                ...state,
                elements: {
                    ...state.elements,
                    [action.data.pathname]: action.data.canonical
                }
            };

        default:
            return state;
    }
}
export default reducer;
